(() => {
  if (window.relenserCoverage) return;
  const active = new Map();
  const selector = '[data-relenser-coverage]';
  function init(section) {
    if (active.has(section)) return;
    if (section.dataset.animate !== 'true' || typeof window.IntersectionObserver !== 'function' ||
        typeof window.matchMedia !== 'function' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      section.classList.add('is-drawn');
      observer.disconnect();
    }, {threshold: 0.2});
    active.set(section, observer);
    observer.observe(section.querySelector('.rlcov-canvas') || section);
  }
  function mount(root) {
    if (root.matches?.(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }
  function unmount(root) {
    for (const [section, observer] of active) {
      if (root === section || root.contains(section)) {
        observer.disconnect();
        active.delete(section);
      }
    }
  }
  window.relenserCoverage = {mount, unmount};
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
})();
